<div class="breadcrumbs" *ngIf="!state?.isWebview">
  <a [routerLink]="['/']" class="santa-typo-additional santa-text-black-500 santa-cursor-pointer">
    {{ translations.home | translate }}
  </a>

  <ng-container *ngIf="state?.items && state?.items?.length">
    <ng-container *ngFor="let item of state.items; last as isLast; trackBy: trackByFn">
      <alliance-icon [name]="ICONS.IconArrowsHorisontalDropdown" [inheritColor]="true" [width]="20" class="santa-text-black-400 santa-mx-10"></alliance-icon>
      <a class="santa-typo-additional" [ngClass]="isLast ? 'santa-text-black-300' : 'santa-text-black-500 santa-cursor-pointer'" [routerLink]="[item.path]" [queryParams]="item.queryParams">
        {{ item.label }}
      </a>
    </ng-container>
  </ng-container>
</div>
